<ng-template [ngIf]="!disableQuadro && (quadroCompensiGrid && quadroCompensiGrid.length > 0)">
<div class="container_conteggi">
<h5><strong>Quadro compensi</strong></h5>
<div class="quadro_compensi margin-top-15 padding-rl-15">
	<p class="col-xs-3 singlecheckbox inlineformelem">
		<span class="fakelabel"></span>
	</p>
	<p class="col-xs-2 col-sm-2 singlecheckbox inlineformelem radiobutton">
		<span class="fakelabel">Min</span>
	</p>
	<p class="col-xs-2 col-sm-2 singlecheckbox inlineformelem radiobutton">
		<span class="fakelabel">Med</span>
	</p>
	<p class="col-xs-2 col-sm-2 singlecheckbox inlineformelem radiobutton">
		<span class="fakelabel">Max</span>
	</p>
	<p class="col-xs-3 col-sm-3 singlecheckbox inlineformelem radiobutton">
		<span class="fakelabel padding-left-0">Compenso</span>
	</p>
</div>
<ng-template ngFor let-q [ngForOf]="quadroCompensiGrid" let-iv=index>
<div 
  role="radiogroup"
  aria-labelledby="compenso-group-label"
  class="padding-rl-15 margin-top-15 padding-bottom-15"
>

  <!-- Etichetta del gruppo invisibile -->
  <span id="compenso-group-label" class="sr-only">
    Scelta compenso
  </span>

  <!-- Checkbox di abilitazione -->
  <div class="col-xs-3 col-sm-3 singlecheckbox inlineformelem">
    <input 
      type="checkbox"
      id="{{q.idCheckboxFase}}"
      [checked]="q.checkedFase"
      (change)="gstRadio(q.fase.id, $event.target.checked)"
    >
    <label for="{{q.idCheckboxFase}}">Abilita compenso</label>
  </div>

  <!-- Radio Min -->
  <div class="col-xs-2 col-sm-2 singlecheckbox inlineformelem radiobutton">
    <input 
      type="radio"
      name="{{q.nameRadio}}"
      id="{{q.idRadioMin}}"
      [value]="q.valoreMinimo"
      [checked]="q.checkedMin"
      [disabled]="!q.checkedFase || q.disabledMin"
      [attr.aria-disabled]="(!q.checkedFase || q.disabledMin) ? 'true' : null"
      (click)="settaImportoFase(q.fase.id, q.valoreMinimo, 0, q.checkedMin)"
    >
    <label for="{{q.idRadioMin}}">{{q.valoreMinimo | euro}} € (minimo)</label>
  </div>

  <!-- Radio Medio -->
  <div class="col-xs-2 col-sm-2 singlecheckbox inlineformelem radiobutton">
    <input 
      type="radio"
      name="{{q.nameRadio}}"
      id="{{q.idRadioMed}}"
      [value]="q.valoreMedio"
      [checked]="q.checkedMed"
      [disabled]="!q.checkedFase || q.disabledMed"
      [attr.aria-disabled]="(!q.checkedFase || q.disabledMed) ? 'true' : null"
      (click)="settaImportoFase(q.fase.id, q.valoreMedio, 1, q.checkedMed)"
    >
    <label for="{{q.idRadioMed}}">{{q.valoreMedio | euro}} € (medio)</label>
  </div>

  <!-- Radio Massimo -->
  <div class="col-xs-2 col-sm-2 singlecheckbox inlineformelem radiobutton">
    <input 
      type="radio"
      name="{{q.nameRadio}}"
      id="{{q.idRadioMax}}"
      [value]="q.valoreMassimo"
      [checked]="q.checkedMax"
      [disabled]="!q.checkedFase || q.disabledMax"
      [attr.aria-disabled]="(!q.checkedFase || q.disabledMax) ? 'true' : null"
      (click)="settaImportoFase(q.fase.id, q.valoreMassimo, 2, q.checkedMax)"
    >
    <label for="{{q.idRadioMax}}">{{q.valoreMassimo | euro}} € (massimo)</label>
  </div>

  <!-- Input libero -->
  <div class="col-xs-3 col-sm-3">
    <p textInputCurrency 
       [(ngModel)]="q.compenso"
       [labelInput]="'Importo personalizzato'"
       [submitPending]="q.disabledImporto"
       [location]="'SezioneQuadroParcelle'"
       (onReturn)="disableRadio(q)">
    </p>
  </div>

</div>

</ng-template>

<div class="padding-bottom-15 padding-rl-15 margin-top-15">
	<p class="col-sm-offset-7 col-sm-2">
		<label class="padding-left-0"  for="totale-parc-strag-lbl">Importo</label>
	</p>
	<p class="col-sm-3">
		<input id="totale-parc-strag-lbl" name="totale" class="totale form-control alignright" disabled="true" value="{{ricalcolaTotale()| euro}} &euro;" type="text">
	</p>
</div>
</div>
</ng-template>
